export default __webpack_public_path__ + "static/media/downloadPdfWhite.2f4731f3.svg";